import { CUSTOMER_DETAILS_QUERY_KEYS } from "../constants/CustomerDetailsQueryKeys.constants";

export const getDetailsQueryKeys = (entityId) => ({
  details: [CUSTOMER_DETAILS_QUERY_KEYS.DETAILS, { id: entityId }],
});

export const getTimelineLogsQueryKeys = (page, entityId, restParams = {}) => ({
  timelineLogs: [
    CUSTOMER_DETAILS_QUERY_KEYS.TIMELINE_LOGS,
    { page, id: entityId, ...restParams },
  ],
});

export const invalidateTimelineLogsForEntity = (queryClient, entityId) => {
  if (!entityId) return;

  queryClient.invalidateQueries({
    predicate: (query) => {
      const [key, meta] = query.queryKey ?? [];
      return (
        key === CUSTOMER_DETAILS_QUERY_KEYS.TIMELINE_LOGS &&
        String(meta?.id) === String(entityId)
      );
    },
  });
};

export const getFormResponsesQueryKeys = (formResponsesId) => ({
  formResponses: [
    CUSTOMER_DETAILS_QUERY_KEYS.FORM_RESPONSES,
    { id: formResponsesId },
  ],
});

export const getCommunicationInfoQueryKeys = (
  communicationInfoId,
  infoKey
) => ({
  info: [
    CUSTOMER_DETAILS_QUERY_KEYS.COMMUNICATION_INFO,
    { id: communicationInfoId, infoKey },
  ],
});
